import { ERROR_FLAG } from '@nettbureau/kvittering-utils';
import React from 'react';

export default function ({ flag }) {
  return flag === ERROR_FLAG ? (
    <div>
      <h1>Teknisk feil</h1>
      <div className="order-receipt--alert">
        <p>
          Det har dessverre oppstått en teknisk feil som gjorde at vi ikke klarte å registrere detaljene dine eller
          sende inn forespørselen din. Prøv igjen senere, eller kontakt oss på{' '}
          <a href="maito:kontakt@strøm.no">kontakt@strøm.no</a>, slik at vi kan hjelpe deg videre.
        </p>
      </div>
    </div>
  ) : null;
}
